// extracted by mini-css-extract-plugin
export default {"wrapper":"DeleteIcon_wrapper__f3e9X","label":"DeleteIcon_label__Os6W6"};